export const _ = document.querySelector.bind(document)
export const __ = document.querySelectorAll.bind(document)

/** @type {(sec: number) => Promise<void>} */
export const sleep = sec => new Promise(resolve => setTimeout(resolve, sec))

export const asyncImagesLoad = () => Promise.all(Array.from(__("img"), el => el.asyncLoad()))
